export const meetingTypes = [
  'Free Consultation',
  'New Customer (UPS) Discovery Call',
  'UPS Customer Intro',
  '15 Min Meeting with Kevin',
]

export const calendlyUuid = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i

function bookingIds(data) {
  if (data?.event !== 'calendly.event_scheduled') return null
  const eventUri = data.payload?.event?.uri
  const inviteeUri = data.payload?.invitee?.uri
  if (typeof eventUri !== 'string' || typeof inviteeUri !== 'string') return null
  const event = eventUri.match(/^https:\/\/api\.calendly\.com\/scheduled_events\/([^/?#]+)$/)
  const invitee = inviteeUri.match(/^https:\/\/api\.calendly\.com\/(?:api\/v2\/)?scheduled_events\/([^/?#]+)\/invitees\/([^/?#]+)$/)
  if (!event || !invitee || event[1] !== invitee[1] || !calendlyUuid.test(event[1]) || !calendlyUuid.test(invitee[2])) return null
  return { eventUuid: event[1], inviteeUuid: invitee[2] }
}

export function createBookingTracker({ frames, storage, lookup, track, onError }) {
  const pending = new Set()
  const recorded = new Set()

  return async message => {
    if (message.origin !== 'https://calendly.com' || !message.source) return
    const frame = frames().find(frame => frame.contentWindow === message.source && frame.src.startsWith('https://calendly.com/'))
    const booking = frame && bookingIds(message.data)
    if (!booking || pending.has(booking.inviteeUuid) || recorded.has(booking.inviteeUuid)) return
    const key = `calendly-booking:${booking.inviteeUuid}`
    try {
      if (storage?.getItem(key)) return
    } catch { /* Browser storage can be disabled; the in-memory set still prevents repeat messages. */ }

    pending.add(booking.inviteeUuid)
    try {
      const meetingType = await lookup(booking.eventUuid)
      if (!meetingTypes.includes(meetingType)) throw new Error('Unrecognized Calendly meeting type.')
      track('Meeting booked', { props: { meeting_type: meetingType } })
      recorded.add(booking.inviteeUuid)
      try { storage?.setItem(key, '1') } catch { /* Tracking does not require browser storage. */ }
    } catch (error) {
      onError(error)
    } finally {
      pending.delete(booking.inviteeUuid)
    }
  }
}
